export default __webpack_public_path__ + "static/media/circle-checked.0e34728e.png";